// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3779) return "static/chunks/5f8dfda4.a15e4b9071ec7eed.js";
	if (chunkId === 1040) return "static/chunks/1040.e300ebf16bd8e5c9.js";
	if (chunkId === 5449) return "static/chunks/4a7b0c69.3f2d021b534195cb.js";
	if (chunkId === 2367) return "static/chunks/2367.d34ceb5b943966c5.js";
	if (chunkId === 9720) return "static/chunks/9720.8940eb10e62fdc0b.js";
	if (chunkId === 1876) return "static/chunks/1876.afb4d2f089a18a59.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1137":"cd4998df979a80d2","1243":"38041b6df227de7a","3639":"57976653fffa2274","3925":"65e65720c38ec388","5976":"a476fc8c4e9bf4e0","7122":"bfd65f524a8cba33","7608":"8f0bfcbe8445310d","7704":"d559af9549dd1299","9038":"66493046ee725f16"}[chunkId] + ".js";
};